import API_ENDPOINTS from 'services/urls';
import axiosInstance from 'ns_libs/nsAxios';
import { useMutation } from '@tanstack/react-query';
import { IErrorResponse, IDealGroup } from '../types';

interface IUpdateDealGroupColorRequest {
    dealGroupId: number;
    orgId: string;
    color: string | null;
}

const updateDealGroupColor = async ({ dealGroupId, orgId, color }: IUpdateDealGroupColorRequest): Promise<IDealGroup> => {
    try {
        const response = await axiosInstance.put<IDealGroup>(
            API_ENDPOINTS.DEALS_GROUPS_BY_ID(orgId, dealGroupId),
            { color },
        );
        return response.data;
    } catch (error) {
        if (error.response?.status !== 500) {
            const errorData: IErrorResponse = error.response?.data;
            throw new Error(errorData?.detail);
        }
        throw new Error('An unexpected error occurred. Please try again.');
    }
};

export const useUpdateDealGroupColor = () => useMutation<IDealGroup, Error, IUpdateDealGroupColorRequest>({
    mutationFn: updateDealGroupColor,
});
